<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<title>Stop Recording</title>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.417 20.25H5.583C4.57 20.25 3.75 19.429 3.75 18.417V5.583C3.75 4.57 4.571 3.75 5.583 3.75H18.416C19.429 3.75 20.249 4.571 20.249 5.583V18.416C20.25 19.429 19.429 20.25 18.417 20.25Z" fill="#FFFFFF"/>
</svg>
